import axios from "axios"
import Profile from "./profile"
import Main from '../main'


// const host = location.hostname.includes('localhost')? '/': 'https://id.novaposhta.ua/profile';
const host = '/';
const csrfToken = document.getElementsByName("authenticity.token")[0] ? document.getElementsByName("authenticity.token")[0].value : "";
// axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
// axios.defaults.headers.post['Content-Type'] = 'application/json';

const axiosInstance = axios.create({
    baseURL: host,
    method: "post",
    timeout: 20000,
    headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
    }
});
    
function getFilteredError(error) {
    if (error.response)
        return error.response;
    else if (error.code && error.code === "ECONNABORTED")
        return {status: 503, message: error.message};
    else if (error.message && error.message === "Network Error")
        return {status: 106, message: error.message};
    else
        return {status: 520, message: error.message};
}

export function getApiErrorMessage(err, additionalErrors = {}) {
    for (let key in additionalErrors)
        if (key == err.status)
            return additionalErrors[key];
    let message = '';
    switch (err.status) {
        case 106: message = Main.$ml.get('errorNetwork'); break;
        case 405: Main.$router.push('/errorPage/405'); break;
        case 429: message = Main.$ml.get('errorTooManyAttempts'); break;
        case 503: message = Main.$ml.get('errorRequestTimeout'); break;
        case 520: message = Main.$ml.get('errorUnknown'); break;
        default: Main.$router.push('/errorPage/'+err.status);
    }
    return message;
}

export function login(profileData) {
    return new Promise((resolve, reject) => {
        Profile.setData(profileData);
        let request = {
            language: Profile.language,
            username: Profile.username,
            otptype: Profile.otptype,
            challenge: Profile.challenge,
            deviceId: Profile.getDeviceId()
        };
        axiosInstance.post('/login', request).then(resp => {
            let data = resp.data;
            if ('deviceId' in data && data.deviceId) {
                Profile.setDeviceId(data.deviceId);
            }
            if ('redirect_to' in data && data['redirect_to'])
                window.location = data['redirect_to'];

            Profile.setData({
                registration: data.registration,
                squestionList: data.squestionlist,
                process: data.registration ? 'registration' : 'login',
            });
            resolve(data);
        }).catch(error => {
            reject(getFilteredError(error));
        });
    });
}

export function verifySms(code) {
    if (Profile.process === 'accessRecovery')
        return recoveryVerifySms(code);
    else {
        return new Promise((resolve, reject) => {
            Profile.setData({
                otpcode: code,
            });
            let request = {
                language: Profile.language,
                username: Profile.username,
                otptype: Profile.otptype,
                challenge: Profile.challenge,
                deviceId: Profile.getDeviceId(),
                otpcode: code,
                otpsend: false,
            };
            axiosInstance.post('/'+Profile.process, request).then(resp => {
                if (resp.status === 200) {
                    let data = resp.data;
                    if ('redirect_to' in data && data['redirect_to']) {
                        window.location = data['redirect_to'];
                        return;
                    }
                    if (Profile.process === 'login')
                        Profile.setData({
                            squestion: data.squestion,
                            stips: data.stips,
                            slanguage: data.slanguage,
                            needsetphone: data.needsetphone,
                            needsetpincode: data.needsetpincode,
                            needsetquestion: data.needsetquestion,
                            squestionList: data.squestionlist || Profile.squestionList,
                        });
                    resolve(data);
                } else
                    reject(resp);
            }).catch(error => {
                Profile.setData({
                    otpcode: '',
                });
                reject(getFilteredError(error));
            });
        });
    }
}

export function resendSms() {
    if (Profile.process === 'accessRecovery')
        return recoverySendSms(true);
    else {
        return new Promise((resolve, reject) => {
            let request = {
                language: Profile.language,
                username: Profile.username,
                otptype: Profile.otptype,
                challenge: Profile.challenge,
                deviceId: Profile.getDeviceId(),
                otpsend: true,
            };
            axiosInstance.post('/'+Profile.process, request)
                .then(resp => resolve(resp.data))
                .catch(error => reject(getFilteredError(error)));
        });
    }
}

export function sendCodeByCall() {
    if (Profile.process === 'accessRecovery')
        return recoverySendCodeByCall();
    else {
        return new Promise((resolve, reject) => {
            let request = {
                language: Profile.language,
                username: Profile.username,
                otptype: 'voip',
                challenge: Profile.challenge,
                deviceId: Profile.getDeviceId(),
                otpsend: true,
            };
            axiosInstance.post('/'+Profile.process, request)
                .then(resp => resolve(resp.data))
                // .catch(error => reject(getFilteredError(error)));
        });
    }
}
export function resendSmsForSecondOtp() {
    return new Promise((resolve, reject) => {
        let request = {
            language: Profile.language,
            username: Profile.username,
            otptype: Profile.otptype,
            challenge: Profile.challenge,
            deviceId: Profile.getDeviceId(),
            sanswer: Profile.sanswer,
            pincode: Profile.pincode,
            secondOTP: {
                username: Profile.secondOTP.username,
                otptype: Profile.secondOTP.otptype,
                otpcode: Profile.secondOTP.otpcode,
                otpsend: true,
            }
        };
        let url = '/' + Profile.process;
        if (Profile.process === "accessRecovery") {
            Object.assign(request, {
                lastName: Profile.lastName,
                firstName: Profile.firstName,
                middleName: Profile.middleName,
                birthdayDate: Profile.birthdayDate,
            });
            url = '/recovery'
        }
        axiosInstance.post(url, request)
            .then(resp => resolve(resp.data))
            .catch(error => reject(getFilteredError(error)));
    });
}

export function sendCodeByCallForSecondOtp() {
    return new Promise((resolve, reject) => {
        let request = {
            language: Profile.language,
            username: Profile.username,
            otptype: Profile.otptype,
            challenge: Profile.challenge,
            deviceId: Profile.getDeviceId(),
            sanswer: Profile.sanswer,
            pincode: Profile.pincode,
            secondOTP: {
                username: Profile.secondOTP.username,
                otptype: 'voip',
                otpcode: Profile.secondOTP.otpcode,
                otpsend: true,
            }
        };
        let url = '/' + Profile.process;
        if (Profile.process === "accessRecovery") {
            Object.assign(request, {
                lastName: Profile.lastName,
                firstName: Profile.firstName,
                middleName: Profile.middleName,
                birthdayDate: Profile.birthdayDate,
            });
            url = '/recovery'
        }
        axiosInstance.post(url, request)
            .then(resp => resolve(resp.data))
            // .catch(error => reject(getFilteredError(error)));
    });
}

export function resendSmsForThirdOtp() {
    return new Promise((resolve, reject) => {
        let request = {
            language: Profile.language,
            username: Profile.username,
            otptype: Profile.otptype,
            challenge: Profile.challenge,
            deviceId: Profile.getDeviceId(),
            lastName: Profile.lastName,
            firstName: Profile.firstName,
            middleName: Profile.middleName,
            birthdayDate: Profile.birthdayDate,
            secondOTP: Profile.secondOTP,
            thirdOTP: {
                username: Profile.thirdOTP.username,
                otptype: Profile.thirdOTP.otptype,
                otpcode: Profile.thirdOTP.otpcode,
                otpsend: true,
            }
        };
        axiosInstance.post('/recovery', request)
            .then(resp => resolve(resp.data))
            .catch(error => reject(getFilteredError(error)));
    });
}

export function sendCodeByCallForThirdOtp() {
    return new Promise((resolve, reject) => {
        let request = {
            language: Profile.language,
            username: Profile.username,
            otptype: Profile.otptype,
            challenge: Profile.challenge,
            deviceId: Profile.getDeviceId(),
            lastName: Profile.lastName,
            firstName: Profile.firstName,
            middleName: Profile.middleName,
            birthdayDate: Profile.birthdayDate,
            secondOTP: Profile.secondOTP,
            thirdOTP: {
                username: Profile.thirdOTP.username,
                otptype: 'voip',
                otpcode: Profile.thirdOTP.otpcode,
                otpsend: true,
            }
        };
        axiosInstance.post('/recovery', request)
            .then(resp => resolve(resp.data))
    });
}

export function verifySecretCode(code, type = 'question') {
     
   
    return new Promise((resolve, reject) => {
        let request = {
            language: Profile.language,
            username: Profile.username,
            otptype: Profile.otptype,
            challenge: Profile.challenge,
            deviceId: Profile.getDeviceId(),
            // otpcode: Profile.otpcode,
            otpsend: false,
        };
        if (type === 'question') {
            Profile.setData({
                sanswer: code,
                pincode: ''
            });
            request.sanswer = code;
        } else {
            Profile.setData({
                sanswer: '',
                pincode: code
            });
            request.pincode = code;
        }

        axiosInstance.post('/login', request).then(resp => {
            if (resp.status === 200) {
                let data = resp.data;
                if ('redirect_to' in data && data['redirect_to']) {
                    Profile.redirectTo = data['redirect_to'];
                    window.location = data['redirect_to'];
                }
                console.log(resp, data);
                resolve(data);
            } else
                reject(resp);
        }).catch(error => {
            reject(getFilteredError(error));
        });
    });
}



export function sendRegistationCode(otpType = 'sms') {
    return new Promise((resolve, reject) => {
        Profile.setData({'otptype': otpType });
        let request = {
            language: Profile.language,
            username: Profile.username,
            otptype: Profile.otptype,
            challenge: Profile.challenge,
            deviceId: Profile.getDeviceId()
        };
        axiosInstance.post('/registration', request).then(resp => {
            let data = resp.data;
            if ('redirect_to' in data && data['redirect_to'])
                window.location = data['redirect_to'];
            resolve(data);
        }).catch(error => {
            if (otpType !== 'voip')
                reject(getFilteredError(error));
        });
    });
}

export function sendSecondOtpCode() {
    return new Promise((resolve, reject) => {
        let request = {
            language: Profile.language,
            username: Profile.username,
            otptype: Profile.otptype,
            challenge: Profile.challenge,
            deviceId: Profile.getDeviceId(),
            sanswer: Profile.sanswer,
            pincode: Profile.pincode,
            secondOTP: Profile.secondOTP
        };
        let url = '/' + Profile.process;
        if (Profile.process === "accessRecovery") {
            Object.assign(request, {
                lastName: Profile.lastName,
                firstName: Profile.firstName,
                middleName: Profile.middleName,
                birthdayDate: Profile.birthdayDate,
                recoveryMethod: Profile.recoveryMethod,
            });
            url = '/recovery'
        }
        axiosInstance.post(url, request).then(resp => {
            let data = resp.data;
            if (('redirect_to' in data) && data['redirect_to'])
                window.location = data['redirect_to'];
            else
                resolve(data);
        }).catch(error => {
            if (Profile.secondOTP.otptype !== 'voip')
                reject(getFilteredError(error));
        });
    });
}

export function sendThirdOtpCode() {
    return new Promise((resolve, reject) => {
        let request = {
            language: Profile.language,
            username: Profile.username,
            otptype: Profile.otptype,
            challenge: Profile.challenge,
            deviceId: Profile.getDeviceId(),
            lastName: Profile.lastName,
            firstName: Profile.firstName,
            middleName: Profile.middleName,
            birthdayDate: Profile.birthdayDate,
            recoveryMethod: Profile.recoveryMethod,
            secondOTP: Profile.secondOTP,
            thirdOTP: Profile.thirdOTP
        };
        axiosInstance.post('/recovery', request).then(resp => {
            resolve(resp.data);
        }).catch(error => {
            if (Profile.secondOTP.otptype !== 'voip')
                reject(getFilteredError(error));
        });
    });
}

export function registerProfile(isReady = false, secondOTPCode = '') {
    return new Promise((resolve, reject) => {
        let request = {
            language: Profile.language,
            username: Profile.username,
            challenge: Profile.challenge,
            deviceId: Profile.getDeviceId(),
            lastName: Profile.lastName,
            firstName: Profile.firstName,
            middleName: Profile.middleName,
            birthdayDate: Profile.birthdayDate,
            pincode: Profile.pincode,
            registerQuestion: Profile.registerQuestion,
            sanswer: Profile.registerAnswer,
            registerAnswerLang: Profile.registerAnswerLang,
            registerTip: Profile.registerTip,
            isready: isReady,
            secondOTP: {
                username: Profile.secondOTP.username,
                otptype: Profile.secondOTP.otptype,
                otpcode: secondOTPCode,
                otpsend: false,
            }
        };
        axiosInstance.post('/registration', request).then(resp => {
            if (resp.status === 200) {
                let data = resp.data;
                Profile.setData({
                    redirectTo: data['redirect_to'],
                });
                resolve(data);
            } else
                reject(resp);
        }).catch(error => {
            reject(getFilteredError(error));
        });
    });
}


export function getRecoveryContacts() {
    return new Promise((resolve, reject) => {
        let request = {
            challenge: Profile.challenge,
            language: Profile.language,
            username: Profile.username,
            lastName: Profile.lastName,
            firstName: Profile.firstName,
            middleName: Profile.middleName,
            birthdayDate: Profile.birthdayDate,
            recoveryMethod: '',
        };
        axiosInstance.post('/recovery', request).then(resp => {
            if (resp.status === 200) {
                let data = resp.data;
                Profile.setData({
                    recoveryContacts: data.recoverylist,
                    needsetphone: data.needsetphone,
                    needsetemail: data.needsetemail
                });
                resolve(data);
            } else
                reject(resp);
        }).catch(error => {
            reject(getFilteredError(error));
        });
    });
}

export function recoverySendSms(isResend = false) {
    return new Promise((resolve, reject) => {
        let request = {
            challenge: Profile.challenge,
            language: Profile.language,
            username: Profile.username,
            lastName: Profile.lastName,
            firstName: Profile.firstName,
            middleName: Profile.middleName,
            birthdayDate: Profile.birthdayDate,
            otpsend: isResend,
            otptype: Profile.otptype,
            recoveryMethod: Profile.recoveryMethod,
        };
        axiosInstance.post('/recovery', request)
            .then(resp => resolve(resp.data))
            .catch(error => reject(getFilteredError(error)));
    });
}

export function recoverySendCodeByCall() {
    return new Promise((resolve, reject) => {
        let request = {
            challenge: Profile.challenge,
            language: Profile.language,
            username: Profile.username,
            lastName: Profile.lastName,
            firstName: Profile.firstName,
            middleName: Profile.middleName,
            birthdayDate: Profile.birthdayDate,
            otpsend: true,
            otptype: 'voip',
            recoveryMethod: Profile.recoveryMethod,
        };
        axiosInstance.post('/recovery', request)
            .then(resp => resolve(resp.data))
            // .catch(error => reject(getFilteredError(error)));
    });
}


export function recoveryVerifySms(code) {
    return new Promise((resolve, reject) => {
        Profile.setData({
            otpcode: code,
        });
        let request = {
            challenge: Profile.challenge,
            language: Profile.language,
            username: Profile.username,
            lastName: Profile.lastName,
            firstName: Profile.firstName,
            middleName: Profile.middleName,
            birthdayDate: Profile.birthdayDate,
            // otpsend: true,
            otptype: Profile.otptype,
            recoveryMethod: Profile.recoveryMethod,
            otpcode: code,
        };
        axiosInstance.post('/recovery', request).then(resp => {
            if (resp.status === 200) {
                let data = resp.data;
                Profile.setData({
                    needsetphone: data.needsetphone,
                    needsetemail: data.needsetemail,
                    squestionList: data.squestionlist
                });
                resolve(data);
            } else
                reject(resp);
        }).catch(error => {
            Profile.setData({
                otpcode: '',
            });
            reject(getFilteredError(error));
        });
    });
}

export function recoverySetSecretAnswers() {
    return new Promise((resolve, reject) => {
        let request = {
            challenge: Profile.challenge,
            language: Profile.language,
            username: Profile.username,
            lastName: Profile.lastName,
            firstName: Profile.firstName,
            middleName: Profile.middleName,
            birthdayDate: Profile.birthdayDate,
            otptype: Profile.otptype,
            // otpcode: Profile.otpcode,
            recoveryMethod: Profile.recoveryMethod,
            pincode: Profile.pincode,
            registerQuestion: Profile.registerQuestion,
            registerAnswer: Profile.registerAnswer,
            registerAnswerLang: Profile.registerAnswerLang,
            registerTip: Profile.registerTip,
            secondOTP: {
                username: Profile.secondOTP.username,
                otptype: Profile.secondOTP.otptype,
                otpcode: '',
                otpsend: false,
            },
            thirdOTP: {
                username: Profile.thirdOTP.username,
                otptype: Profile.thirdOTP.otptype,
                otpcode: '',
                otpsend: false,
            },

        };
        axiosInstance.post('/recovery', request).then(resp => {
            if (resp.status === 200) {
                let data = resp.data;
                Profile.setData({ redirectTo: data['redirect_to'] });
                resolve(data);
            } else
                reject(resp);
        }).catch(error => {
            reject(getFilteredError(error));
        });
    });
}

//сохранение пинкода и скретного вопроса при логине, если их не было
export function setSecretData() {
    return new Promise((resolve, reject) => {
        let request = {
            language: Profile.language,
            challenge: Profile.challenge,
            username: Profile.username,
            otptype: Profile.otptype,
            deviceId: Profile.getDeviceId(),
            pincode: Profile.pincode,
            secondOTP: {
                username: Profile.secondOTP.username,
                otptype: Profile.secondOTP.otptype,
                otpcode: '',
                otpsend: false,
            }
        }
        if (Profile.needsetpincode)
            request.pincode = Profile.pincode;
        if (Profile.needsetquestion) {
            request = Object.assign({},request, {
                registerQuestion: Profile.registerQuestion,
                sanswer: Profile.registerAnswer,
                registerAnswerLang: Profile.registerAnswerLang,
                registerTip: Profile.registerTip,
            })
        }

        axiosInstance.post('/login', request).then(resp => {
            if (resp.status === 200) {
                let data = resp.data;
                if ('redirect_to' in data && data['redirect_to']) {
                    window.location = data['redirect_to'];
                } else
                    resolve(data);
            } else
                reject(resp);
        }).catch(error => {
            reject(getFilteredError(error));
        });
    });
}

export function detectionBrowser () {
    function cBrowser() {
        const ua = navigator.userAgent;
        const bName = function () {
            if (ua.search(/MSIE/) > -1) return "ie";
            else if (ua.search(/Firefox/) > -1) return "firefox";
            else if (ua.search(/Opera/) > -1) return "opera";
            else if (ua.search(/Chrome/) > -1) return "chrome";
            else if (ua.search(/CriOS/) > -1) return "crios";
            else if (ua.search(/Safari/) > -1) return "safari";
            else if (ua.search(/Konqueror/) > -1) return "konqueror";
            else if (ua.search(/Iceweasel/) > -1) return "iceweasel";
            else if (ua.search(/SeaMonkey/) > -1) return "seamonkey";
            else return "other"}();
        const version = function (bName) {
            switch (bName) {
                case "ie" : return (ua.split("MSIE ")[1]).split(";")[0];break;
                case "firefox" : return ua.split("Firefox/")[1];break;
                case "opera" : return ua.split("Version/")[1];break;
                case "chrome" : return (ua.split("Chrome/")[1]).split(" ")[0];break;
                case "crios" : return (ua.split("CriOS/")[1]).split(" ")[0];break;
                case "safari" : return (ua.split("Version/")[1]).split(" ")[0];break;
                case "konqueror" : return (ua.split("KHTML/")[1]).split(" ")[0];break;
                case "iceweasel" : return (ua.split("Iceweasel/")[1]).split(" ")[0];break;
                case "seamonkey" : return ua.split("SeaMonkey/")[1];break;
                case "other": return ''
            }}(bName);
        return {
            name: bName,
            version:version.split(".")[0],
            fullVersion: bName + version
        };
    }
    return cBrowser()
}
